class AlwaysOnAI {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/always-on-ai`;

  }

  get() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  updateSettings(patch) {

    const path = `${this.basePath}/settings`;

    return this.apiClient.put(path, {}, {}, patch);

  }

  applyRecommendedSettings(mainDigestStartupUserIds, urgentAlertStartupUserIds) {

    const path = `${this.basePath}/settings/apply-recommended`;

    const payload = {
      mainDigestStartupUserIds,
      urgentAlertStartupUserIds
    };

    return this.apiClient.post(path, {}, {}, payload);

  }

  pause() {

    const path = `${this.basePath}/pause`;

    return this.apiClient.post(path, {}, {}, {});

  }

  resume() {

    const path = `${this.basePath}/resume`;

    return this.apiClient.post(path, {}, {}, {});

  }

  generateNow(forceSend) {

    const path = `${this.basePath}/generate-now`;

    const payload = {
      forceSend
    };

    return this.apiClient.post(path, {}, {}, payload);

  }

  listDigests(limit) {

    const path = `${this.basePath}/digests`;

    return this.apiClient.get(path, {}, { limit });

  }

  getDigest(digestId) {

    const path = `${this.basePath}/digests/:digestId`;

    return this.apiClient.get(path, { digestId }, {});

  }

}

export default AlwaysOnAI;